import AttachmentTypeRoutes from './attachmentType'
import BenefitTypeRoutes from './benefitType'
import CategoryRoutes from './category'
// ABDA-78: LocalTrainingRoutes e ModalityRoutes removidas — CRUD migrou pro sistema novo.
import OccurrenceTypeRoutes from './occurrenceType'
import SchoolRoutes from './school'
import SocialAttendanceTypeRoutes from './socialAttendanceType'
import SocialEntityRoutes from './socialEntity'
import TeacherRoutes from './teacher'
import AnamneseRoutes from './anamnese'
import QuestionsRoutes from './question'
import MessageSmsRoutes from './smsservice'

const ConfigurationRoutes = [
  ...AttachmentTypeRoutes,
  ...BenefitTypeRoutes,
  ...CategoryRoutes,
  ...OccurrenceTypeRoutes,
  ...SchoolRoutes,
  ...SocialAttendanceTypeRoutes,
  ...SocialEntityRoutes,
  ...TeacherRoutes,
  ...AnamneseRoutes,
  ...QuestionsRoutes,
  ...MessageSmsRoutes
]

export default ConfigurationRoutes
